import { getChannelType, MessageAuthorType } from "./chat.common";
export const ChatMapper = {
    channelToDomain(channel, unreadCount, lastMessagePreview = "") {
        return {
            id: channel.id,
            name: channel.name,
            displayName: channel.display_name,
            type: getChannelType(channel.name),
            header: channel.header,
            lastPostAt: channel.last_post_at,
            totalMsgCount: channel.total_msg_count,
            unreadCount,
            creatorId: channel.creator_id,
            lastMessagePreview,
        };
    },
    postToDomain(post, authorName, authorType) {
        const resolvedName = authorType === MessageAuthorType.CLIENT
            ? ChatMapper.extractClientName(post.message)
            : authorName;
        return {
            id: post.id,
            channelId: post.channel_id,
            authorId: post.user_id,
            authorName: resolvedName,
            authorType,
            message: authorType === MessageAuthorType.CLIENT
                ? post.message.replace(/^:raising_hand:\s*Клиент\s+.+?:\n/, "")
                : post.message,
            createAt: post.create_at,
            rootId: post.root_id || null,
            replyCount: post.reply_count ?? 0,
            fileIds: post.file_ids || [],
            props: post.props || {},
        };
    },
    extractClientName(message) {
        const match = message.match(/^:raising_hand:\s*Клиент\s+(.+?):\n/);
        return match?.[1] ?? "Клиент";
    },
    getAuthorType(post, currentUserId, botUserId) {
        if (post.user_id === currentUserId)
            return MessageAuthorType.DISPATCHER;
        if (post.user_id === botUserId) {
            return post.message.startsWith(":raising_hand:")
                ? MessageAuthorType.CLIENT
                : MessageAuthorType.BOT;
        }
        return MessageAuthorType.TECHNICIAN;
    },
};
